<template>
  <div class="w-100 px-3">
    <CRow class="justify-content-between mb-2 mt-2">
      <CCol sm="12"
        ><h4>
          <span>{{ $t("family.dashboard.markets.cta") }} 📢</span>
        </h4>
      </CCol>
    </CRow>

    <div class="loading text-center" v-if="loading">
      <CSpinner color="primary" size="lg" />
    </div>

    <CRow>
      <CCol v-for="market in markets" :key="market.id" sm="12">
        <MarketBoxMarketing :market="market" />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { GetDataManagerNew, ApiCall } from "../../ds";
import { Query } from "@syncfusion/ej2-data";
import { mapGetters } from "vuex";
import MarketBoxMarketing from "../user/partials/MarketBoxMarketing.vue";

export default {
  name: "UiMarkets",
  components: {
    MarketBoxMarketing,
  },

  data() {
    return {
      initialized: false,
      loading: false,
      markets: [],
      numPages: 1,
      currentPage: 1,
    };
  },

  computed: {
    ...mapGetters("connections", ["familyId"]),
  },

  mounted() {
    this.initialized = true;
    this.getMarkets();
  },

  watch: {
    currentPage: function () {
      this.getMarkets();
    },
  },

  methods: {
    getMarkets() {
      const self = this;
      self.loading = true;
      const query = new Query();
      const itemsPerPage = 3;
      query.page(this.currentPage, itemsPerPage);
      ApiCall(
        GetDataManagerNew("family_markets", [this.familyId]),
        query,
        (e) => {
          self.numPages = Math.ceil(e.actual.payload.Count / itemsPerPage);
          self.markets = e.result.filter((m) => m.market.mtype !== 2);
          self.loading = false;
        },
        (e) => {
          console.error(e);
          self.loading = false;
        }
      );
    },

    changeZipCode() {},
  },
};
</script>
